import { useAccount, useDisconnect } from 'wagmi'

import { AddressDisplay, Button, Tooltip } from '~/components/component-library'

export const DisconnectButton = ({ fullWidth }: { fullWidth?: boolean }) => {
  const { disconnect } = useDisconnect()
  const { isConnected, address } = useAccount()

  if (!isConnected) {
    return null
  }

  return (
    <Tooltip
      content={
        <div>
          You are currently connected {address ? 'as ' : ''}
          {address && <AddressDisplay address={address} layout="inline-text" />}
        </div>
      }
    >
      <Button
        variant="secondary"
        fullWidth={fullWidth}
        onClick={(e) => {
          e.stopPropagation()
          disconnect()
        }}
      >
        Disconnect
      </Button>
    </Tooltip>
  )
}
